import React from 'react';
import Aux from '../../hoc/Aux';

const formattedPrice = ( props ) => (

    <Aux><sup>$</sup>{props.price.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0})}</Aux>

);

export default formattedPrice;